import { FC } from 'react';
import { CouponsItemView } from '../components';

export const CouponsItemPage: FC = props => <CouponsItemView />;
